var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackpadGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.650879 3C0.650879 1.34314 1.99402 0 3.65088 0H22.3492C24.0061 0 25.3492 1.34315 25.3492 3V17C25.3492 18.6568 24.0061 20 22.3492 20H13.8443V17.3448C13.8443 16.8791 13.4667 16.5015 13.001 16.5015C12.5353 16.5015 12.1577 16.8791 12.1577 17.3448V20H3.65088C1.99403 20 0.650879 18.6568 0.650879 17V3ZM23.8647 14.4383C23.8647 14.0074 23.5155 13.6581 23.0846 13.6581L3.04995 13.6581C2.61908 13.6581 2.2698 14.0074 2.2698 14.4383C2.2698 14.8692 2.61908 15.2184 3.04995 15.2184L23.0846 15.2184C23.5155 15.2184 23.8647 14.8692 23.8647 14.4383Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackpadGrey);
export default __webpack_public_path__ + "static/media/Trackpad_grey.8e0e54c4412ef3a7f5990a6f6302fcf0.svg";
export { ForwardRef as ReactComponent };